export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAKCAYAAACE2W/HAAAAGElEQVQokWNUTV70n4EMwESOplGNw0cjAOE3Aj20rt3eAAAAAElFTkSuQmCC"